import React from 'react';
import {Page, Text, View, Document, Font} from '@react-pdf/renderer';
import {withTranslation} from "react-i18next";
import {EXT_TITLE, VERSION} from "../../../../config/consts";
import {styles} from "./styles";
import Groups from "./Groups";
import font from "../../../../assets/fonts/arial-unicode-ms.ttf";
import config from "../../../../config/config";

Font.register({
  family: 'pdfFont',
  src: font
});

const ExportPdfGroupsActivity = ({t, data: exportData}) => {
  return (
    <Document>
      <Page style={styles.body}>
        <Text style={styles.header} fixed>{t("Created by")} {config.appTitle || EXT_TITLE} {VERSION}</Text>
        <View style={styles.headerPadding} fixed/>


        <Groups data={exportData} />

        <Text style={styles.pageNumber} render={({pageNumber, totalPages}) => (
          `${pageNumber} / ${totalPages}`
        )} fixed/>
      </Page>
    </Document>
  )
};


export default withTranslation()(ExportPdfGroupsActivity);